module.exports = __webpack_public_path__ + "static/media/02.7ec261b6.png";